import { Box, Container, Heading, Image, Stack, Text } from '@chakra-ui/react'
import React from 'react'
import { Carousel } from 'react-responsive-carousel'
import "react-responsive-carousel/lib/styles/carousel.min.css"
import img1 from "../assests/1.jpg"
import img2 from "../assests/2.jpg"
import img3 from "../assests/3.jpg"
import img4 from "../assests/4.jpg"
import img5 from "../assests/5.png"

const headingOptions = {
  pos:"absolute",
  left:"50%",
  top:"50%",
  transform:"translate(-50%,-50%)",
  textTransform:"uppercase",
  p:"4",
  size:"4xl",
}

const Home = () => {
  return (
    <Box>
        <MyCarousel />
        <Container maxW={"container.xl"} minH={'100vh'} p="16">
          <Heading textTransform={"uppercase"} py='2' w={"fit-content"} borderBottom={'2px solid'} m="auto">Services</Heading>

          <Stack h="full" p={'4'} alignItems={'center'} direction={['column','row']}>
            <Image src={img5} h={['40','400']} filter={'hue-rotate(-130deg)'}/>
            <Text letterSpacing={'widest'} lineheight={'190%'} p={['4','16']} textAlign='center'>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Aspernatur repellat voluptatum, vero incidunt sapiente harum alias saepe quo ipsa? Perferendis animi aut ut dolore, dolorem tempora voluptates eligendi maxime omnis excepturi facere commodi sit minima asperiores repellendus est. Facilis deserunt quo, corrupti odit sint voluptate fuga! Fugit odit eum beatae autem accusamus, delectus optio officia, labore impedit ipsa velit aperiam pariatur porro reprehenderit esse architecto, ipsam a doloremque perferendis libero. Laborum a placeat distinctio eos veritatis explicabo sit praesentium quaerat?
            </Text>

          </Stack>


        </Container>
    </Box>
  )
}
const MyCarousel = () =>(
    <Carousel autoPlay infiniteLoop interval={1000} showStatus={false} showArrows={false} showThumbs={false}>
        <Box w='full' h={'100vh'}>
            <Image src={img1} />
            <Heading bgColor={'blackAlpha.600'} color={'white'} {...headingOptions}> Watch The Future</Heading>
            </Box>
        <Box w='full' h={'100vh'}>
            <Image src={img2} />
            <Heading bgColor={'blackAlpha.700'} color={'white'} {...headingOptions}>Console Gaming</Heading>
        </Box>
        <Box w='full' h={'100vh'}>
            <Image src={img3} />
            <Heading bgColor={'blackAlpha.600'} color={'white'} {...headingOptions}>Future is Gaming</Heading>
        </Box>
        <Box w='full' h={'100vh'}>
            <Image src={img4} />
            <Heading bgColor={'blackAlpha.600'} color={'white'} {...headingOptions}>Nightlife Gaming</Heading>
        </Box>
    </Carousel>
)
export default Home